import { render } from "./VideoLayer.vue?vue&type=template&id=7da6f365"
import script from "./VideoLayer.vue?vue&type=script&lang=js"
export * from "./VideoLayer.vue?vue&type=script&lang=js"

import "./VideoLayer.vue?vue&type=style&index=0&id=7da6f365&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__